import api from "./api";

const RESOURCE = "/api/parametro";

const Parameter = {
  defaultPageLimit: async () =>
    await api.get(RESOURCE + "/tamanho-padrao-paginacao"),

  findAllParameters: async (page, pageLimit) =>
    await api.get(RESOURCE + `?page=${page}&size=${pageLimit}`),

  editValue: async (id, dataSending) =>
    await api.put(RESOURCE + `/editar-valor/${id}`, dataSending),
};

export default Parameter;
